import Home from "../components/home/Home";
// import ContentPage from "../components/ContentPage";
import NewsPage from "../components/news/NewsPage";
import NewsStory from "../components/news/NewsStory";
import NotFound from "../components/NotFound";

// Reviewer
import ReviewerLogin from "../components/reviewer/login/ReviewerLogin";
import ReviewerLogout from "../components/reviewer/ReviewerLogout";
import ReviewerProfile from "../components/reviewer/profile/ReviewerProfile";
import ChangePassword from "../components/reviewer/profile/ChangePassword";
import PasswordRequest from "../components/reviewer/password-request/PasswordRequest";
import CreateAccount from "../components/reviewer/create/CreateAccount";

// Reviews
import Reviews from "../components/reviews/Reviews";
import RelatedReviews from "../components/reviews/RelatedReviews";
import PastReviews from "../components/reviews/PastReviews";
import AllReviews from "../components/reviews/AllReviews";
import ReviewRecord from "../components/reviews/ReviewRecord";

// Training
import Training from "../components/training/Training";
import TrainingVideos from "../components/training/videos/TrainingVideos";
import VideoPage from "../components/training/videos/VideoPage";
import TrainingDocs from "../components/training/documents/TrainingDocs";
import TrainingEducation from "../components/training/education/TrainingEducation";
import TrainingSurveys from "../components/training/surveys/TrainingSurveys";

// FAQ
import FaqPage from "../components/faq/FaqPage";

// Admin
import AdminLogin from "../components/admin/login/AdminLogin";
import Admin from "../components/admin/Admin";

// import AdminFileBrowser from "../components/admin/AdminFileBrowser";

import {
	adminIsAuthenticated,
	adminIsNotAuthenticated,
	/*adminIsAuthenticatedNoLogin,*/ reviewerIsAuthenticated,
	reviewerIsNotAuthenticated
} from "./auth";

import GARouteWrapper from "../components/GARouteWrapper";

export default [
	{
		path: "/",
		exact: true,
		component: GARouteWrapper(Home),
		props: {
			translationKey: "home"
		}
	},

	// ===================================
	//  NEWS
	// ===================================
	{
		path: "/news/:permalink",
		component: GARouteWrapper(NewsStory)
		// props: {
		// 	translationKey: "news_listing"
		// }
	},
	{
		path: "/news",
		component: GARouteWrapper(NewsPage)
		// props: {
		// 	translationKey: "news_listing"
		// }
	},

	// ===================================
	//  REVIEWER
	// ===================================
	{
		path: "/reviewer/login",
		component: reviewerIsNotAuthenticated(ReviewerLogin),
		exact: true,
		props: {
			translationKey: "reviewer-login"
		}
	},
	{
		path: "/reviewer/logout",
		exact: true,
		component: reviewerIsAuthenticated(ReviewerLogout)
	},
	{
		path: "/reviewer/request-password",
		component: reviewerIsNotAuthenticated(PasswordRequest),
		props: {
			translationKey: "reviewer_request_password"
		}
	},
	{
		path: "/reviewer/register",
		component: reviewerIsNotAuthenticated(CreateAccount),
		props: {
			translationKey: "reviewer-register"
		}
	},
	{
		path: "/reviewer",
		component: reviewerIsAuthenticated(ReviewerProfile),
		props: {
			translationKey: "reviewer_profile"
		}
	},

	// ===================================
	//  Change Password
	// ===================================
	{
		path: "/change-password",
		component: reviewerIsAuthenticated(ChangePassword),
		props: {
			translationKey: "change_password"
		}
	},

	// ===================================
	//  Reviews
	// ===================================
	{
		path: "/reviews/related",
		exact: true,
		component: reviewerIsAuthenticated(RelatedReviews),
		props: {
			translationKey: "my-reviews"
		}
	},
	{
		path: "/reviews/past",
		exact: true,
		component: reviewerIsAuthenticated(PastReviews),
		props: {
			translationKey: "past-reviews"
		}
	},
	{
		path: "/reviews/all",
		exact: true,
		component: reviewerIsAuthenticated(AllReviews),
		props: {
			translationKey: "all-reviews"
		}
	},
	{
		path: "/reviews/:id",
		component: reviewerIsAuthenticated(ReviewRecord),
		props: {
			translationKey: "review-profile"
		}
	},
	{
		path: "/reviews",
		exact: true,
		component: reviewerIsAuthenticated(Reviews),
		props: {
			translationKey: "reviews"
		}
	},

	// ===================================
	//  Training
	// ===================================
	{
		path: "/training/videos/:id",
		exact: true,
		component: reviewerIsAuthenticated(VideoPage),
		props: {
			translationKey: "training-video"
		}
	},
	{
		path: "/training/videos",
		exact: true,
		component: reviewerIsAuthenticated(TrainingVideos),
		props: {
			translationKey: "training-videos"
		}
	},
	{
		path: "/training/documents",
		exact: true,
		component: reviewerIsAuthenticated(TrainingDocs),
		props: {
			translationKey: "training-documents"
		}
	},
	{
		path: "/training/education",
		exact: true,
		component: reviewerIsAuthenticated(TrainingEducation),
		props: {
			translationKey: "training-education"
		}
	},
	{
		path: "/training/surveys",
		exact: true,
		component: reviewerIsAuthenticated(TrainingSurveys),
		props: {
			translationKey: "training-surveys"
		}
	},
	{
		path: "/training",
		exact: true,
		component: reviewerIsAuthenticated(Training),
		props: {
			translationKey: "training"
		}
	},

	// ===================================
	//  FAQ
	// ===================================
	{
		path: "/faq",
		component: FaqPage,
		props: {
			translationKey: "faq"
		}
	},

	// ===================================
	//  ADMIN
	// ===================================
	{
		path: "/admin/login",
		component: adminIsNotAuthenticated(AdminLogin)
	},
	{
		path: "/admin",
		component: adminIsAuthenticated(Admin)
	},

	// ===================================
	//  MISC
	// ===================================
	// {
	// 	path: "/image-browser",
	// 	component: adminIsAuthenticatedNoLogin(AdminFileBrowser),
	// 	exact: true
	// },
	// {
	// 	path: "/file-browser",
	// 	component: adminIsAuthenticatedNoLogin(AdminFileBrowser),
	// 	exact: true
	// },
	// {
	// 	path: "/search-results",
	// 	component: SearchProducts
	// },

	// ===================================
	//  MISC
	// ===================================
	// {
	// 	path: "/:permalink",
	// 	component: GARouteWrapper(ContentPage)
	// },
	{
		component: NotFound
	}
];



// WEBPACK FOOTER //
// ./src/shared/routes.js